module.exports = __webpack_public_path__ + "static/media/500723.a010b2d4.svg";